import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { WorkerType, WorkerTypeException } from './worker-type.interface';

export class WorkerTypeService {
   async getWorkerTypes(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<Array<WorkerType>>>(`/worker-types`, { params: { ...query } });
      return response.data.data;
   }

   async getWorkerTypeExceptions(query?: LocationQuery) {
      const response = await http.get<Array<WorkerTypeException>>(`/worker-type-exceptions`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
